import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';

// Стили Telegram UI
import '@telegram-apps/telegram-ui/dist/styles.css';
// Кастомная тема СТОТЕК
import './styles/theme.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
